import { render, staticRenderFns } from "./SLWiseMateriality.vue?vue&type=template&id=39e7f3f1&scoped=true"
import script from "./SLWiseMateriality.vue?vue&type=script&lang=js"
export * from "./SLWiseMateriality.vue?vue&type=script&lang=js"
import style0 from "./SLWiseMateriality.vue?vue&type=style&index=0&id=39e7f3f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e7f3f1",
  null
  
)

export default component.exports